import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { Entity } from '../types/entity';
import { PutResponseBody } from '../types/api-response';
import queryClient from '../query-client';

export type UpdateEntitiesProviderRequest = {
    xeroUserId: string;
    xeroEntities: { id: string; tenantId: string; connectionId: string }[];
};

async function updateEntitiesProvider(req: UpdateEntitiesProviderRequest): Promise<PutResponseBody<Entity>> {
    const { data } = await api.put(`/entities/provider`, req);
    return data;
}

export function useUpdateEntitiesProvider(
    { invalidate } = { invalidate: true }
): UseMutationResult<PutResponseBody<Entity>, AxiosError, UpdateEntitiesProviderRequest, unknown> {
    return useMutation(updateEntitiesProvider, {
        onSettled: () => {
            if (invalidate) {
                queryClient.invalidateQueries(['entities']);
            }
        },
    });
}
